export const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";
